export function walkTreeItems(treeItems, callback) {
    for (const item of treeItems) {
        callback(item);
        if (item.children) {
            walkTreeItems(item.children, callback);
        }
    }
}
